export enum Country {
  Australia = 'AU',
  Canada = 'CA',
  Malaysia = 'MY',
  NewZealand = 'NZ',
  // Qatar = 'QA',
  SaudiArabia = 'SA',
  Singapore = 'SG',
  UnitedArabEmirates = 'AE',
  UnitedKingdom = 'GB',
  UnitedStates = 'US',
  Netherlands = 'NL',
  Belgium = 'BE',
  Germany = 'DE',
  France = 'FR',
  // Temporarily hide Spain until we have a way to support it
  // Spain = 'ES',
  Poland = 'PL',
  // temporarily hide Turkey until we have a way to support it
  // Turkey = 'TR',
  Kazakhstan = 'KZ',
  Mongolia = 'MN',
  // Uzbekistan = 'UZ',
  Azerbaijan = 'AZ',
  Switzerland = 'CH',
  Denmark = 'DK',
  Norway = 'NO',
  Japan = 'JP',
  Mexico = 'MX',
  Chile = 'CL',
  Colombia = 'CO',
}

export const CountryLabel: Record<Country, string> = {
  [Country.Australia]: 'Australia',
  [Country.Canada]: 'Canada',
  [Country.Malaysia]: 'Malaysia',
  [Country.NewZealand]: 'New Zealand',
  // [Country.Qatar]: 'Qatar',
  [Country.SaudiArabia]: 'Saudi Arabia',
  [Country.Singapore]: 'Singapore',
  [Country.UnitedArabEmirates]: 'United Arab Emirates',
  [Country.UnitedKingdom]: 'United Kingdom (UK)',
  [Country.UnitedStates]: 'United States (USA)',
  [Country.Netherlands]: 'Netherlands',
  [Country.Belgium]: 'Belgium',
  [Country.Germany]: 'Germany',
  [Country.France]: 'France',
  // [Country.Spain]: 'Spain',
  [Country.Poland]: 'Poland',
  // [Country.Turkey]: 'Turkey',
  [Country.Kazakhstan]: 'Kazakhstan',
  [Country.Mongolia]: 'Mongolia',
  // [Country.Uzbekistan]: 'Uzbekistan',
  [Country.Azerbaijan]: 'Azerbaijan',
  [Country.Switzerland]: 'Switzerland',
  [Country.Denmark]: 'Denmark',
  [Country.Norway]: 'Norway',
  [Country.Japan]: 'Japan',
  [Country.Mexico]: 'Mexico',
  [Country.Chile]: 'Chile',
  [Country.Colombia]: 'Colombia',
} as const;

export const CountryDialCode = {
  [Country.Australia]: '+61',
  [Country.Canada]: '+1',
  [Country.Malaysia]: '+60',
  [Country.NewZealand]: '+64',
  // [Country.Qatar]: '+974',
  [Country.SaudiArabia]: '+966',
  [Country.Singapore]: '+65',
  [Country.UnitedArabEmirates]: '+971',
  [Country.UnitedKingdom]: '+44',
  [Country.UnitedStates]: '+1',
  [Country.Netherlands]: '+31',
  [Country.Belgium]: '+32',
  [Country.Germany]: '+49',
  [Country.France]: '+33',
  // [Country.Spain]: '+34',
  [Country.Poland]: '+48',
  // [Country.Turkey]: '+90',
  [Country.Kazakhstan]: '+7',
  [Country.Mongolia]: '+976',
  // [Country.Uzbekistan]: '+998',
  [Country.Azerbaijan]: '+994',
  [Country.Switzerland]: '+41',
  [Country.Denmark]: '+45',
  [Country.Norway]: '+47',
  [Country.Japan]: '+81',
  [Country.Mexico]: '+52',
  [Country.Chile]: '+56',
  [Country.Colombia]: '+57',
} as const;

// ISO 3166-1 alpha-2 코드 (전세계 국가)
export type PhoneCountryCode = string;
